'use strict'
import React from 'react'

const GetHighlightedText = (text, highlight) => {
  const onlyLettersAndNumbers = highlight.replace(/[^A-Za-z0-9]+/gi,'')
  const parts = text.split(new RegExp(`(${onlyLettersAndNumbers})`, 'gi'))

  if ( highlight === undefined ) {
    return text
  }

  return (
    <span>
      {parts.map((part, i) =>
        <span key={i} className={part.toLowerCase() === highlight.toLowerCase() ? 'highlighted-text' : ''}>
          {part}
        </span>
      )}
    </span>
  )
}

export default GetHighlightedText
